import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getCheckoutInsuranceQuoteParamsByType } from '../request/getCheckoutInsuranceQuoteParams'
import getCheckoutInsuranceProducts from './getCheckoutInsuranceProducts'
import { getInsuranceQuoteKey, insuranceTypeToInsuranceProductType } from 'lib/insurance/insuranceUtils'

const getCheckoutInsuranceQuotes = createSelector(
  (state: App.State, type?: App.InsuranceProductType) => getCheckoutInsuranceQuoteParamsByType(state, type),
  (state: App.State) => state.insurance.quotes,
  (state: App.State, type?: App.InsuranceProductType) => getCheckoutInsuranceProducts(state, type),
  (quoteParams, quotes, products): Array<App.InsuranceQuote> => {
    const checkoutQuotes = products.map(product => {
      const key = getInsuranceQuoteKey(
        product.id,
        {
          type: insuranceTypeToInsuranceProductType(product.type),
          ...quoteParams,
        },
      )
      return quotes[key]
    })

    return nonNullable(checkoutQuotes)
  },
)

export default getCheckoutInsuranceQuotes
